import axios from "axios";
import { getToken } from "./authUtils";

// Create an axios instance with the default headers
const api = axios.create({
  // baseURL: "https://api.sarvajna.co.in/qp/controller/",
  // baseURL: "https://qp.sarvajna.co.in/old/api/controller/", 
  
// baseURL: "https://api.sarvajna.co.in/qp/controller/", 

// baseURL: "https://api.sarvajna.co.in/qp/controller/",


  // baseURL: "http://192.168.1.103/projects/sarvajna/qp-sarvajna/controller", 



  // baseURL: "https://devpanel.online/sar-qp/controller_onezo", // Your base API URL/

  baseURL: "https://edu.onezo.in/qp_ind/controller/", // Your base API URL/
  // baseURL: "https://devpanel.online/school_api/qp_ind/controller/", // Your base API URL/


// http://192.168.29.178
  
});

// Add the Authorization header to each request
api.interceptors.request.use(
  (config) => {
    const token = getToken(); // Get the token from localStorage
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`; // Set the token in the Authorization header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
